const reportsConstants = {
	REPORTS_LIST_REQUEST: 'REPORTS_LIST_REQUEST',
	REPORTS_LIST_SUCCESS: 'REPORTS_LIST_SUCCESS',
	REPORTS_LIST_FAILURE: 'REPORTS_LIST_FAILURE',
	REPORTS_LIST_SEARCH: 'REPORTS_LIST_SEARCH',
};
export default reportsConstants;
